import axios from "axios";
import { verifyToken } from "utils/Funciones";
import { BACKEND } from "utils/contants";
const API_URL = `${BACKEND}/api/marca/`;

const create = async (formData, token) => {
    const response = await axios.post(API_URL, formData, {
        headers: {
            Authorization: 'Bearer ' + token
        },
    });
    return response.data;
};

const get = async (token) => {
    const response = await axios.get(API_URL, {
        headers: {
            Authorization: 'Bearer ' + token,
            'Content-Type': 'application/json'
        },
    });
    return response.data;
};

const getByPage = async (query, token) => {
    const response = await axios.get(API_URL + `bypage${query}`, {
        headers: {
            Authorization: 'Bearer ' + token,
            'Content-Type': 'application/json'
        },
    });
    return response.data;
};

const del = async (_id, token) => {
    const response = await axios.delete(API_URL + _id, {
        headers: {
            Authorization: 'Bearer ' + token,
            'Content-Type': 'application/json'
        },
    });
    return response.data;
};

const update = async (formData, token) => {
    const response = await axios.patch(API_URL + 'marca', formData, {
        headers: {
            Authorization: 'Bearer ' + token
        },
    });
    return response.data;
};

const marcaService = {
    create,
    get,
    getByPage,
    update,
    del
};

export default marcaService;
